function roundToFixedAndParseFloat(value, fixedSize) {
  return parseFloat(value.toFixed(fixedSize));
}

function formatRatePlanAmount(value) {
  return (+value.toFixed(1)).toString();
}

function formatNumberWithFixed(value, fixedSize) {
  return parseFloat(value).toFixed(fixedSize);
}

function normalizePastedPhone(text) {
  const value = text.trim().replace(/^tel:/i, '').replace(/[\s().-]/g, '').replace(/^00/, '+');
  return /^\+\d+$/.test(value) ? value : text.trim();
}

export { roundToFixedAndParseFloat, formatRatePlanAmount, formatNumberWithFixed, normalizePastedPhone };
